import Vue from 'vue';
import { Hypotheek } from '@/model/Hypotheek';
import { IBetaling } from '@/model/IBetaling';
import { State } from 'vuex-class';
import * as _ from 'lodash';
import Component from 'vue-class-component';
import { IHypothekenData } from '@/store/IHypothekenData';
import { IHypotheekdeel } from '@/model/IHypotheekdeel';

@Component
export class AppHypotheekMixin extends Vue {
  @State(state => state.hypotheken)
  private hypothekenData!: IHypothekenData;
  @State(state => state.betalingen)
  public betalingen!: IBetaling[];

  get hypotheken(): Hypotheek[] {
    return this.hypothekenData && this.hypothekenData.hypotheken;
  }

  get hypotheek(): Hypotheek | undefined {
    return this.hypotheken.find(h => h.id === this.hypothekenData.currentHypotheeknummer);
  }

  get hypotheeknummer(): string {
    return this.hypothekenData && this.hypothekenData.currentHypotheeknummer;
  }

  get currentHypotheekdeel(): IHypotheekdeel | undefined {
    return (
      this.hypotheek &&
      (_.find(this.hypotheek.hypotheekdelen, {
        hypotheeknummer: this.hypothekenData.currentHypotheekdeelnummer
      }) as IHypotheekdeel)
    );
  }

  get hasMultipleHypotheken(): boolean {
    return !!(this.hypotheken && this.hypotheken.length > 1);
  }

  get hasAnyBouwdepot(): boolean {
    return !!(this.hypotheken && this.hypotheken.find(h => !!h.bouwdepot));
  }

  get canAnyWoningwaardeWijzigen(): boolean {
    return !!(this.hypotheek && this.hypotheken.find(h => h.canWoningwaardeWijzigen));
  }
}
